import * as Sentry from "@sentry/react"
import { useEffect } from "react"
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
  createBrowserRouter,
} from "react-router"

declare const __APP_VERSION__: string

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
const GRAPHQL_URI = import.meta.env.VITE_GRAPHQL_URI
const MODE = import.meta.env.MODE
const isProd = MODE === "production"

Sentry.init({
  dsn: SENTRY_DSN,
  environment: MODE,
  release: __APP_VERSION__,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: isProd ? 0.2 : 1.0,
  tracePropagationTargets: GRAPHQL_URI ? [new URL(GRAPHQL_URI).origin] : [],
  replaysSessionSampleRate: isProd ? 0.1 : 0,
  replaysOnErrorSampleRate: isProd ? 1.0 : 0,
})

export const sentryCreateBrowserRouter: typeof createBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter)
